var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.expires)?_c('div',{staticClass:"ims-countdown"},[(_vm.expired)?_c('div',[_vm._t("finished")],2):_c('div',[_vm._t("during"),_vm._v(" "+_vm._s(_vm.remaining))],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }